module.exports = __webpack_public_path__ + "img/phone.63d70a63.svg";